import { DialogLayout, NewConvergeButton } from '../../../presentation';
import { Box, Stack } from '@mui/material';

interface ReopenClaimProps {
  open: boolean;
  onClose: () => void;
  title: string;
  handleReopenClaim: () => void;
  submitLabel: string;
  context: string;
  loading: boolean;
}

export const ReopenClaimModal = ({
  open,
  onClose,
  title,
  handleReopenClaim,
  context,
  submitLabel,
  loading,
}: ReopenClaimProps) => {
  return (
    <DialogLayout
      data-testid="reopen-claim-modal"
      open={open}
      onClose={onClose}
      showCloseButton={true}
      onCloseIconClick={onClose}
      header={<Box className="modal-title-reopen"> {title}</Box>}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: '700px',
          maxWidth: '700px',
        },
      }}
    >
      <Stack className="content-reopen-claim-message">{context}</Stack>
      <Stack className="modal-btn-container-reopen-claim">
        <Box style={{ marginRight: '15px' }}>
          <NewConvergeButton
            label="CANCEL"
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          />
        </Box>
        <Box>
          <NewConvergeButton
            label={submitLabel}
            loading={loading}
            onClick={() => handleReopenClaim()}
          />
        </Box>
      </Stack>
    </DialogLayout>
  );
};
